/**
 * 菜单栏翻译
 **/
export default{
  charts: "图表",
  collection: {
    generateQRPlate: "制作收款码牌",
    remoteQR: "远程收款码",
    title: "收款"
  },
  complaints: "消费者投诉",
  paymentAnalytics: {
    merchantGroupStats: "商户组统计",
    outletStats: "营业点统计",
    projectStats: "项目统计",
    title: "支付统计"
  },
  paymentOrders: {
    downloadOrders: "支付订单下载",
    eDocuments: "电子单据",
    paymentOrders: "支付订单",
    preAuthOrders: "预授权订单",
    title: "支付订单"
  },
  profitSharing: {
    details: "分账流水",
    stats: "分账统计",
    title: "分账"
  },
  reconciliation: {
    calendar: "对账月历",
    details: "对账流水",
    downloadData: "对账数据下载",
    stats: "对账统计",
    title: "支付对账",
    uploadStatement: "上传账单对账"
  },
  settings: {
    customColumns: "自定义列设置",
    merchantGroupConfig: "商户组设置",
    outletConfig: "营业点设置",
    projectConfig: "项目设置",
    terminal: "终端",
    title: "设置"
  },
  settlement: {
    payeeMgmt: "收款方管理",
    payout: "结算打款",
    ruleConfig: "结算规则设置",
    stats: "结算统计",
    title: "结算"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/cn/menus.js